<template>
  <div class="user-center">
    <h1>用户中心</h1>
<!--    <div class="user-info">-->
<!--      <p><strong>用户名:</strong> {{ username }}</p>-->
<!--      <p><strong>邮箱:</strong> {{ email }}</p>-->
<!--    </div>-->

    <el-descriptions
        direction="vertical"
        border
        style="margin-top: 30px"
    >

      <el-descriptions-item label="用户名">{{ username }}</el-descriptions-item>
      <el-descriptions-item label="邮箱">{{ email }}</el-descriptions-item>

    </el-descriptions>
    <br><br>

    <!-- 修改后的评论列表 -->
    <div >
      <h2>我的评论      共 {{comments.length}}条</h2>
      <div v-if="comments.length > 0">
        <div v-for="comment in comments" :key="comment.id" >
          <br>
          <el-card style="max-width: 1111180px">
            <template #header>
              <div class="card-header">
                <span>
                  <el-row :gutter="20" align="middle">
                    <el-col :span="12">
                      <el-rate v-model="comment.rating" class="ml-1" disabled />
                      <el-text>{{ getRatingDescription(comment.rating) }}</el-text>
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                      <el-button
                          color="#626aef"
                          @click="editComment(comment)"
                          type="primary"
                          :icon="Edit"
                          style="background: linear-gradient(135deg, #6a8cff, #626aef); border: none;"
                      />
                      <el-button
                          color="#626aef"
                          @click="deleteComment(comment.id)"
                          type="primary"
                          :icon="Delete"
                          style="background: linear-gradient(135deg, #ff6b6b, #ff4444); border: none;"
                      />
                    </el-col>
                  </el-row>
                </span>


              </div>
            </template>
            <p><strong>自证认识导师:</strong> {{ comment.voice_volume }}</p>
            <p><strong>学术水平:</strong> {{ comment.academic_level }}</p>
            <p><strong>科研经费:</strong> {{ comment.research_funds }}</p>
            <p><strong>学生补助:</strong> {{ comment.student_allowance }}</p>
            <p><strong>师生关系:</strong> {{ comment.teacher_student_relationship }}</p>
            <p><strong>工作时间:</strong> {{ comment.work_hours }}</p>
            <p><strong>学生前景:</strong> {{ comment.student_prospects }}</p>
            <template #footer>
              <div class="comment-header">
                <span>状态: {{
                    comment.status === 'approved' ? '通过审核' :
                        comment.status === 'pending' ? '待审核' :
                            '未通过审核！'
                  }}
                </span>
                <span>创建时间: {{ formatDate(comment.created_at) }}</span>
                <span>更新时间: {{ formatDate(comment.updated_at) }}</span>
              </div>



            </template>



          </el-card>

        </div>
      </div>
      <p v-else>暂无评论</p>
    </div>


  </div>




  <!-- 添加模态框 -->
  <div v-if="showCommentModal" class="modal-overlay" >
    <div class="modal-content">
      <div class="modal-header">
        <h3>修改评论</h3>
      </div>

      <form @submit.prevent="saveComment">
        <!-- 其他表单字段 -->
        <div class="form-grid">

          <div class="form-group">
            <label>自证认识导师</label>
            <el-input
                v-model="currentComment.voice_volume"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>
          <!-- ... 其他表单字段 ... -->
          <div class="form-group">
            <label>学术水平</label>
            <el-input
                v-model="currentComment.academic_level"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>科研经费</label>
            <el-input
                v-model="currentComment.research_funds"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>学生补助</label>
            <el-input
                v-model="currentComment.student_allowance"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>师生关系</label>
            <el-input
                v-model="currentComment.teacher_student_relationship"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>工作时间</label>
            <el-input
                v-model="currentComment.work_hours"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>学生前途</label>
            <el-input
                v-model="currentComment.student_prospects"
                rows=3
                minlength="10"
                style="width: 500px"
                show-word-limit
                type="textarea"
                required
            />
          </div>

          <div class="form-group">
            <label>评分</label>
            <el-rate
                v-model="currentComment.rating"
                :texts="['天坑导师！快逃！', '勉强能忍，但不推荐', '普普通通，不好不坏', '相当不错，值得推荐', '神仙导师！下次还选！']"
                show-text
                size="large"
                required
            />
          </div>

        </div>

        <div class="form-actions">
          <button type="submit" class="submit-btn">保存</button>
          <button type="button" class="cancel-btn" @click="closeModal">取消</button>
        </div>

      </form>
    </div>
  </div>

</template>

<script>

import {API_BASE_URL} from "@/config";
import axios from "axios";
import {ElMessage, ElMessageBox} from "element-plus";
import {Delete, Edit} from "@element-plus/icons-vue";

export default {
  name: 'UserCenter',
  computed: {
    Delete() {
      return Delete
    },
    Edit() {
      return Edit
    }
  },
  data() {
    return {
      username: '',
      email: '',
      comments: [], // 添加评论列表
      showCommentModal: false,
      currentComment: {
        rating: 0
      },
      originalComment: {},
    }
  },
  mounted() {
    // 从本地存储中获取用户信息
    this.username = localStorage.getItem('username.halfpanda') || '匿名';
    this.email = localStorage.getItem('email.halfpanda') || '';
    this.phone = localStorage.getItem('phone.halfpanda') || '';
    this.fetchComments();
  },
  methods: {
    getRatingDescription(rating) {
      const descriptions = {
        1: '天坑导师！快逃！',
        2: '勉强能忍，但不推荐',
        3: '普普通通，不好不坏',
        4: '相当不错，值得推荐',
        5: '神仙导师！下次还选！'
      };
      return descriptions[rating] || '请选择评分';
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString();
    },
    // 获取用户评论
    async fetchComments() {
      const token = localStorage.getItem('access.halfpanda');

      try {
        const response = await axios.get(`${API_BASE_URL}/user/comment-list`, {
          headers: {
            'Authorization': token
          }
        });

        if (response.data.code === 200) {
          this.comments = response.data.data;
        }
      } catch (error) {
        ElMessage.error('获取评论失败，请稍后重试')
      }
    },

    // 编辑评论
    editComment(comment) {
      document.body.style.overflow = 'hidden';  // 禁止页面滚动
      this.currentComment = {...comment};
      this.originalComment = {...comment}; // 保存原始评论数据
      this.showCommentModal = true;
    },

    // 删除评论
    async deleteComment(commentId) {
      // 弹出确认框，询问用户是否确定保存修改
      try {
        await ElMessageBox.confirm(
            '确定要删除吗？',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
        );
        // 如果用户点击确定，继续执行保存逻辑
        const token = localStorage.getItem('access.halfpanda');
        const response = await axios.delete(`${API_BASE_URL}/user/comment-delete/${commentId}`, {
          headers: {
            'Authorization': token
          }
        })
        if (response.data.code === 200) {
          ElMessage.success('删除成功！');
          await this.fetchComments(); // 刷新评论列表
          this.closeModal(); // 关闭模态框
        }
      }
      catch (error) {
        // 如果用户点击取消，捕获错误并忽略
        if (error === 'cancel') {
          return;
        }
        // 处理其他错误
        console.error('删除失败:', error);
        ElMessage.error('删除评论失败，请稍后重试')
      }
    },


    // 关闭模态框
    closeModal() {
      this.showCommentModal = false;
      document.body.style.overflow = '';  // 恢复页面滚动
    },

    // 保存评论
    async saveComment() {
      // 检查是否有任何字段被修改
      if (
          this.currentComment.rating === this.originalComment.rating &&
          this.currentComment.voice_volume === this.originalComment.voice_volume &&
          this.currentComment.academic_level === this.originalComment.academic_level &&
          this.currentComment.research_funds === this.originalComment.research_funds &&
          this.currentComment.student_allowance === this.originalComment.student_allowance &&
          this.currentComment.teacher_student_relationship === this.originalComment.teacher_student_relationship &&
          this.currentComment.work_hours === this.originalComment.work_hours &&
          this.currentComment.student_prospects === this.originalComment.student_prospects
      ) {
        ElMessage.error('未修改任何内容');
        return;
      }

      // 弹出确认框，询问用户是否确定保存修改
      try {
        await ElMessageBox.confirm(
            '确定要保存修改吗？',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
        );
        // 如果用户点击确定，继续执行保存逻辑
        this.currentComment = {
          comment_id: this.currentComment.id,
          rating: this.currentComment.rating,
          voice_volume: this.currentComment.voice_volume,
          academic_level: this.currentComment.academic_level,
          research_funds: this.currentComment.research_funds,
          student_allowance: this.currentComment.student_allowance,
          teacher_student_relationship: this.currentComment.teacher_student_relationship,
          work_hours: this.currentComment.work_hours,
          student_prospects: this.currentComment.student_prospects
        };

        const token = localStorage.getItem('access.halfpanda');
        const response = await axios.put(
            `${API_BASE_URL}/user/comment-update`,
            this.currentComment,
            {
              headers: {
                'Authorization': token
              }
            }
        );

        if (response.data.code === 200) {
          ElMessage.success('修改成功！');
          await this.fetchComments(); // 刷新评论列表
          this.closeModal(); // 关闭模态框
        } else {
          ElMessage.error('服务器繁忙，请稍后再试！');
        }
      }
      catch (error) {
        // 如果用户点击取消，捕获错误并忽略
        if (error === 'cancel') {
          return;
        }
        // 处理其他错误
        console.error('保存失败:', error);
        ElMessage.error('修改失败，请重试');
      }


    }

  }
}


</script>

<style scoped>

/* 添加模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 1000px; /* 增加宽度 */
  max-height: 90vh;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
.modal-content {
  padding: 30px;
  width: 100%;
  max-width: 1100px; /* 增加宽度 */
}

/* 表单网格布局 */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;  /* 增加网格间距 */
}




.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}



.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 30px; /* 增加下边距 */
}

.star-rating span.active {
  color: #ffcc00;
}

.rating-description {
  margin-left: 10px;
  color: #666;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.submit-btn,
.cancel-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
}

.submit-btn {
  background-color: #007bff;
  color: white;
}

.cancel-btn {
  background-color: #6c757d;
  color: white;
}

.edit-modal label {
  display: block;
  margin: 10px 0;
}

.edit-modal input {
  margin-left: 10px;
  padding: 5px;
}

.comments-section {
  margin-top: 30px;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 5px;
}

.comment-item {
  margin: 15px 0;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 0.9em;
  color: #666;
}

.comment-details {
  margin-top: 10px;
  padding-left: 15px;
  border-left: 3px solid #eee;
}

.comment-actions {
  margin-top: 10px;
  text-align: right;
}

.comment-actions button {
  margin-left: 10px;
  padding: 5px 10px;
  font-size: 14px;
}


.user-center {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.user-info {
  margin-top: 20px;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
}

button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #ff4444;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #cc0000;
}
</style>